import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { requestableCategoryRepository } from '../data-access/repositories/RequestableCategoryRepository'

const base = ['expense-requestable-category']

export const requestableCategoryQueryConfig = {
  locations: () => ({
    queryKey: buildQueryKey([...base, 'locations']),
    queryFn: () => requestableCategoryRepository.listRequestableLocations(),
  }),
  departments: (branchId: number) => ({
    queryKey: buildQueryKey([...base, 'departments', branchId]),
    queryFn: () =>
      requestableCategoryRepository.listRequestableDepartments(branchId),
  }),
}
